// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__czeMn","meals-appear":"AvailableMeals_meals-appear__7hPqT"};